import Vue from 'vue'
class Validations {
  install(Vue) {
    Vue.prototype.$validation = this;
  }

  required(v) {
    return !!v || 'Field is required'
  }

  email(v) {
    return /.+@.+/.test(v) || 'E-mail must be valid'
  }

  max(len) {
    return (v) => v.length <= len || `Must be less than ${len} characters`
  }

  phone(v) {
    if(/\D/.test(v)) return "Only numbers allowed";
    const len = v.length;
    if(len > 10) return `Should be less than ${len} digits`
    if(len < 7) return `Should be atleast 7 digits`
    return undefined;
  }
}
export default Validations;
Vue.use(new Validations());